import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import type { CSSProperties } from 'react';
import styled, { css } from 'styled-components';
import type { FONT_AWESOME_ICONS } from './constants';

export interface IconProps
  extends Pick<
    FontAwesomeIconProps,
    'size' | 'inverse' | 'onClick' | 'fixedWidth' | 'rotation' | 'style' | 'className' | 'aria-label' | 'spin'
  > {
  /**
   * Name of the icon to be displayed. See Icons section for examples.
   */
  iconString: keyof typeof FONT_AWESOME_ICONS;
  /**
   * Color of the icon.
   */
  color?: CSSProperties['color'];
  /**
   * Font-size of the icon. Takes precedence over 'size' prop.
   */
  $fontSize?: CSSProperties['fontSize'];
  hasShadow?: boolean;
}

export const StyledIcon = styled(FontAwesomeIcon)<Omit<IconProps, 'iconString'>>`
  && {
    ${({ color }) =>
      color &&
      css`
        color: ${color};
      `}
    ${({ $fontSize }) =>
      $fontSize &&
      css`
        font-size: ${$fontSize};
      `}


      ${({ theme, hasShadow }) =>
        hasShadow &&
        css`
        filter: drop-shadow(0 0 0.65rem ${theme.color.grey.grey5});
      `}
  }
`;
